<template>
  <v-card title="开票日志">
    <div class="grid-demo">
      <v-more-panel>
        <v-form slot="form">
          <v-form-item label="开票时间">
            <v-date-picker v-model="options.kpsjq"></v-date-picker>
            -
            <v-date-picker v-model="options.kpsjz"></v-date-picker>
          </v-form-item>
          <v-form-item label="状态"
            ><v-select
              style="width: 100px"
              v-model="options.zt"
              :data="zt_options"
            ></v-select
          ></v-form-item>
          <v-form-item label="业务单号">
            <v-input placeholder="" v-model="options.ywdh"></v-input>
          </v-form-item>
          <v-form-item label="UID">
            <v-input placeholder="" v-model="options.uid"></v-input>
          </v-form-item>
        </v-form>
        <v-form-item>
          <v-button type="primary" icon="search" @click="findList()"
            ><span>查询</span></v-button
          >
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid v-bind="xGridOptions" size="mini" ref="xTable" :data="tableData">
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  kpsjq: "",
  kpsjz: "",
  zt: "2",
  ywdh: "",
  uid:""
};
let pagination = {
  sort: "kpsj",
  sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1,
};
let zt_options = [
  { value: "1", label: "成功" },
  { value: "2", label: "失败" },
];
export default {
  data() {
    return {
      pagination,
      options,
      zt_options,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 450,
        headerAlign: "center",
        loading:false,
        columns: [
          {
            field: "rn",
            title: "序号",
            align: "center",
            sortable: true,
          },
          {
            field: "ywdh",
            title: "业务单号",
            align: "center",
            sortable: true,
          },
          {
            field: "uid",
            title: "uid",
            align: "center",
            sortable: true,
          },
          {
            field: "jg",
            title: "开票结果",
            align: "center",
            sortable: true,
          },
          {
            field: "kpsj",
            title: "开票时间",
            align: "center",
            sortable: true,
          },
          {
            field: "lx",
            title: "类型",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let lx = "";
                if (row.lx == "1") {
                  lx = "正票";
                } else {
                  lx = "红票";
                }
                return [<span>{lx}</span>];
              },
            },
          },
          {
            field: "bz",
            title: "状态",
            align: "center",
            sortable: true,
            slots: {
              default: ({ row, column }) => {
                let bz = "";
                if (row.bz == "1") {
                  bz = "成功";
                } else {
                  bz = "失败";
                }
                return [<span>{bz}</span>];
              },
            },
          },
        ],
      },
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.xGridOptions.loading=true
      this.$axios
        .get(
          "api/system/logcx/get-kplog-list?cx=" +
            JSON.stringify(this.options),
          {
            params: this.pagination,
          }
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.pagination.totalresult = res.data.total;
           this.xGridOptions.loading=false
        });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/kplog.vue